import { XmlLog } from "./XmlLog";

export class XmlTrace {

    private _xmlDataType: string;
    private _linkedCtrlTrace: Array<string>;
    private _nodes: Array<string>;
    private _reverseLinkTrace: Array<string>;
    private _overDirectLinkTrace: Array<string>;
    private _enabled: boolean;
    private _log: XmlLog;

    constructor(xmlDataType: string) {
        this._xmlDataType = xmlDataType;
        this._linkedCtrlTrace = [];
        this._reverseLinkTrace = [];
        this._overDirectLinkTrace = [];
        this._nodes = [];
        this._enabled = true;
        this._log = new XmlLog('XmlTrace');
    }

    public dumpLinkTraces(uniqueId: string) {
        if (this._enabled && this._linkedCtrlTrace.length > 0) {
            this._log.setId(uniqueId);
            const nodes = this._nodes.join(" ");
            const agg = this._linkedCtrlTrace.join(" ");
            const reverseAgg = this._reverseLinkTrace.join(" ");
            const overDirectAgg = this._overDirectLinkTrace.join(" ");

            this._linkedCtrlTrace = [];
            this._log.log(this._xmlDataType + " --> http://www.webgraphviz.com/ : digraph G {rankdir=LR;node [style=filled];" + nodes + agg + reverseAgg + overDirectAgg + "}");
        }
    }

    public on() {
        this._enabled = true;
    }

    public off() {
        this._enabled = false;
    }

    public pushLinkTrace(ctrl: IwsControle) {
        let xmlData = ctrl[this._xmlDataType];
        this._nodes.push('"' + ctrl.id + '" [label="' + ctrl.id + ' (level=' + xmlData.evaluationLevel + ')' + '"];');
        if (xmlData.lnCtrl) {
            for (let i = 0; i < xmlData.lnCtrl.length; ++i) {
                let lnCtrl = xmlData.lnCtrl[i];
                this._linkedCtrlTrace.push('"' + ctrl.id + '"->"' + lnCtrl.Key + '" [color="0.650 0.700 0.700"];');
            }
        }
    };

    public pushReverseLinkTrace(from: string, to: string) {
        this._reverseLinkTrace.push('"' + from + '"->"' + to + '" [color="0.002 0.999 0.999" label="inverse supprimé"];');
    }

    public pushOverDirectLinkTrace(from: string, to: string) {
        this._overDirectLinkTrace.push('"' + from + '"->"' + to + '" [color="0.348 0.839 0.839" label="doublon supprimé"];');
    }

}
